import React, { useEffect } from 'react';
import SatButton from '@components/common/satUI/SatButton';
import { toSummaryName } from '@common/utils/index';

const AppReportLnb = props => {
  const {
    currentPage,
    setCurrentPage,
    planMainInfo,
    title1Status,
    setTitle1Status,
    title2Status,
    setTitle2Status,
    isCheckList,
    isRewrite = false,
    type,
    completePage,
    onClickCloseBtn,
    isMinor = false,
  } = props;

  return (
    <nav className="nav app">
      <div className="tit-box">
        <h3 className="insu-tit" onClick={() => setCurrentPage(0)}>
          {planMainInfo.mainProductName}
        </h3>
        <ul className="customer-info">
          {planMainInfo.mainProductName !== '' &&
          planMainInfo.insuredPrspCustNo === planMainInfo.ownerPrspCustNo ? (
            <li>{`계약자 / 피보험자 : ${toSummaryName(
              planMainInfo.insuredPrspInfo.name,
            )} (${planMainInfo.insuredPrspInfo.insuranceAge}세/${
              planMainInfo.insuredPrspInfo.genderLabel
            })`}</li>
          ) : (
            <>
              <li>{`계약자 : ${toSummaryName(
                planMainInfo.ownerPrspInfo.name,
              )} (${planMainInfo.ownerPrspInfo.insuranceAge}세/${
                planMainInfo.ownerPrspInfo.genderLabel
              })`}</li>
              <li>{`피보험자 : ${toSummaryName(
                planMainInfo.insuredPrspInfo.name,
              )} (${planMainInfo.insuredPrspInfo.insuranceAge}세/${
                planMainInfo.insuredPrspInfo.genderLabel
              })`}</li>
            </>
          )}
        </ul>
      </div>
      <ul className="app-step">
        <li className={`${title1Status && isCheckList ? 'complete' : ''}`}>
          <span
            className={`${title1Status && 'open'} ${
              $utils.checkLPText(type) && currentPage > 0 && currentPage < 4
                ? 'active'
                : !$utils.checkLPText(type) &&
                  currentPage > 0 &&
                  currentPage < 5
                ? 'active'
                : ''
            }`}
            onClick={() => {
              setTitle1Status(!title1Status);
            }}
          >
            1.
            {$utils.checkLPText(type)
              ? '라이프파트너 보고서'
              : '보험설계사 보고서'}
            {isRewrite ? ` (재작성)` : ``}
          </span>
          <ul
            className="sub-step"
            style={title1Status ? { display: 'block' } : {}}
          >
            <li>
              <span
                className={`${currentPage === 1 ? 'active' : ''} ${
                  completePage.includes(1) ? 'complete' : ''
                }`}
                onClick={() => setCurrentPage(1)}
              >
                {isMinor ? `친권자 실명증표` : `계약자 실명증표`}
              </span>
            </li>
            <li>
              <span
                className={`${currentPage === 2 ? 'active' : ''} ${
                  completePage.includes(2) ? 'complete' : ''
                }`}
                onClick={() => setCurrentPage(2)}
              >
                {`심사 참고사항`}
              </span>
            </li>
            {$utils.checkLPText(type) ? (
              <li>
                <span
                  className={`${currentPage === 3 ? 'active' : ''} ${
                    completePage.includes(3) ? 'complete' : ''
                  }`}
                  onClick={() => setCurrentPage(3)}
                >
                  {`모집경로 및 면담정보`}
                </span>
              </li>
            ) : (
              <>
                <li>
                  <span
                    className={`${currentPage === 3 ? 'active' : ''} ${
                      completePage.includes(3) ? 'complete' : ''
                    }`}
                    onClick={() => setCurrentPage(3)}
                  >
                    {`모집경로`}
                  </span>
                </li>
                <li>
                  <span
                    className={`${currentPage === 4 ? 'active' : ''} ${
                      completePage.includes(4) ? 'complete' : ''
                    }`}
                    onClick={() => setCurrentPage(4)}
                  >
                    {`면담정보`}
                  </span>
                </li>
              </>
            )}
          </ul>
        </li>
        {isCheckList && (
          <li>
            <span
              className={`${title2Status && 'open'} ${
                $utils.checkLPText(type) && currentPage === 4
                  ? 'active'
                  : !$utils.checkLPText(type) && currentPage === 5
                  ? 'active'
                  : ''
              }`}
              onClick={() => {
                setTitle2Status(!title2Status);
              }}
            >
              {`2. 판매체크리스트`}
            </span>
            <ul
              className="sub-step"
              style={title2Status ? { display: 'block' } : {}}
            >
              <li>
                <span
                  className={`${
                    $utils.checkLPText(type) && currentPage === 4
                      ? 'active'
                      : !$utils.checkLPText(type) && currentPage === 5
                      ? 'active'
                      : ''
                  } ${
                    $utils.checkLPText(type) && completePage.includes(4)
                      ? 'complete'
                      : !$utils.checkLPText(type) && completePage.includes(5)
                      ? 'complete'
                      : ''
                  }`}
                  onClick={() =>
                    $utils.checkLPText(type)
                      ? setCurrentPage(4)
                      : setCurrentPage(5)
                  }
                >
                  {`판매체크리스트`}
                </span>
              </li>
            </ul>
          </li>
        )}
      </ul>
      <div className="nav-bottom">
        <SatButton
          styleClass="btn-s blue btn-wide"
          onClick={() => onClickCloseBtn()}
          label="보고서 작성 닫기"
          iconStyleClass="ico ico-exit"
        ></SatButton>
      </div>
    </nav>
  );
};

export default AppReportLnb;
